import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import onClickOutside from "react-onclickoutside";
import Icon from "react-icons-kit";
import { userCircleO } from "react-icons-kit/fa/userCircleO";
import { withTranslation } from "react-i18next";

class HeaderDropdownPublic extends Component {
  state = {
    dropdownAccPublic: this.props.dropdownAccPublic,
  };
  handleClickOutside = (evt) => {
    // ..handling code goes here...
    //  console.log("outside click header Dropdown Public");
    this.props.callbackFromParent(false);
    this.setState({ dropdownAccPublic: false });
  };
  dropdownAccClick = () => {
    this.setState({ dropdownAccPublic: !this.state.dropdownAccPublic });
  };
  componentDidMount() {
    const userMenu = localStorage.getItem("userMenu");
    //  console.log("receive userMenu ", userMenu);
    this.setState({ dropdownAccPublic: this.props.dropdownAccPublic });
  }
  render() {
    return (
      <div className="nav-action">
        <Icon
          size={34}
          icon={userCircleO}
          onClick={() => {
            this.setState({ dropdownAccPublic: !this.state.dropdownAccPublic });
          }}
        />
        <div
          className={
            this.state.dropdownAccPublic
              ? "wrap-hover public show"
              : "wrap-hover public"
          }
        >
          <div className="wrap-hover-content">
            <Link to="/login" className="dropdown-item">
              {this.props.t("HeaderDropdownPublic.link_masuk")}
            </Link>
            <Link to="/register" className="dropdown-item">
              {this.props.t("HeaderDropdownPublic.link_registrasi")}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(onClickOutside(HeaderDropdownPublic));
